"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NginxTemplate = void 0;
exports.NginxTemplate = `server {
    server_name {{domain}};
    listen 80;

    return 301 https://{{domain}}$request_uri;
}

server {
    listen 443 ssl;

    ssl_certificate "/etc/letsencrypt/live/{{domain}}/fullchain.pem";
    ssl_certificate_key "/etc/letsencrypt/live/{{domain}}/privkey.pem";
    ssl_ciphers EECDH:+AES256:-3DES:RSA+AES:!NULL:!RC4;
    ssl_prefer_server_ciphers on;
    ssl_protocols TLSv1 TLSv1.1 TLSv1.2;
    add_header Strict-Transport-Security "max-age=31536000; includeSubDomains; preload" always;
    ssl_stapling on;

    error_log /var/log/nginx/{{domain}}.error.log error;

    root {{rootPath}}{{domain}};
    error_page 404 /policy/index.html;

    server_name www.{{domain}} {{domain}};

    location / {
        root {{rootPath}}{{domain}};
        add_header 'Access-Control-Allow-Origin' '*';
        add_header 'Access-Control-Allow-Methods' 'GET, POST, OPTIONS';
        add_header 'Access-Control-Allow-Headers' 'Origin, Authorization, Accept, Content-Type, X-Requested-With';
        if ($request_method = 'OPTIONS') {
            return 204;
        }
    }
}
`;
